import { ISetNewsLetterSubscriptionAction } from "../interfaces/utils.interface";
export function setNewsLetterSubscription(isSubscription: boolean): ISetNewsLetterSubscriptionAction {
  return {
    type: "SET_NEWS_LETTER_SUBSCRIPTION",
    data: isSubscription,
  };
}
